import React, { useEffect, useState } from 'react'
import { API_ENDPOINTS } from '../../../utils/api';
import createAxiosInstance from "../../../utils/axiosInstance";
import { CollaborativeType } from '../../../type/Collaborative';
import { Link } from 'react-router-dom';
import Loader from '../../../Components/Loader';

const Collaborative = () => {
  const axiosInstance = createAxiosInstance();

  const [collaboratives, setCollaboratives] = useState<CollaborativeType[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getCollaborativeList();
  }, []);

  const getCollaborativeList = async () => {
    try {
      const response = await axiosInstance.get(API_ENDPOINTS.BEDFINDER.GETCOLLABORATIVELIST);

      const data: CollaborativeType[] = response.data; // Extract the actual data

      setCollaboratives(data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  return (
    <>
      {isLoading && <Loader />}
      <div className='bg-white'>
        <div className="container py-4 md:py-10 2xl:py-[70px]">
          <div className="mb-4">
            <h3 className="text-gray-900 font-bold text-base lg:text-xl 2xl:text-2xl mb-2">Safe Shelter Collaborative Hubs</h3>
          </div>
          <div className="flex flex-wrap -mx-3">
            {collaboratives.map(({ groupId, name, agencies, canViewDetails, description }) => (
              <div className="w-full lg:w-1/2 px-3 mb-5">
                <div className="card p-4 2xl:p-6 h-full">
                  <div className="card-header flex items-center gap-3 mb-3 2xl:mb-5 text-gray-600">
                    {canViewDetails ? (
                      <Link to={`/bedfinder/collaborative/${groupId}`}>
                        <h3 className='text-secondary font-semibold text-sm lg:text-base 2xl:text-xl'>{name}</h3>
                      </Link>
                    ) : (
                      <h3 className='text-secondary font-semibold text-sm lg:text-base 2xl:text-xl'>{name}</h3>
                    )}
                    <span className='bg-orange-50 text-primary py-1.5 px-3 2xl:py-2 text-xs 2xl:text-sm 2xl:px-4 font-medium rounded-full'>{agencies.length} {agencies.length > 1 ? "agencies" : "agency"}</span>
                  </div>
                  {description && (
                    <p className='text-gray-600 text-xs lg:text-sm 2xl:text-base font-medium'
                      dangerouslySetInnerHTML={{
                        __html: description.replace(/\n/g, "<br/>"),
                      }}
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default Collaborative